import { cn } from "../../utils/cn";

type SpinnerSize = "3" | "3.5" | "4" | "5" | "6" | "8";

const sizeClasses: Record<SpinnerSize, string> = {
  "3": "h-3 w-3",
  "3.5": "h-3.5 w-3.5",
  "4": "h-4 w-4",
  "5": "h-5 w-5",
  "6": "h-6 w-6",
  "8": "h-8 w-8",
};

const strokeWidths: Record<SpinnerSize, number> = {
  "3": 3,
  "3.5": 2.5,
  "4": 2.5,
  "5": 2.5,
  "6": 2,
  "8": 2,
};

type SpinnerProps = {
  /** Size in Tailwind units: "3" | "3.5" | "4" | "5" | "6" | "8" */
  size?: SpinnerSize;
  className?: string;
};

/**
 * A smooth, wobble-free loading spinner.
 * Uses a custom SVG circle that rotates perfectly around its center.
 */
export const Spinner = ({ size = "4", className }: SpinnerProps) => {
  const strokeWidth = strokeWidths[size];

  return (
    <svg
      className={cn(sizeClasses[size], "animate-spin", className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background track */}
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        className="opacity-20"
      />
      {/* Animated arc */}
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray="32 32"
        className="opacity-75"
      />
    </svg>
  );
};
